import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '7×24 不打烊',
    description: '全天候实时追踪娱乐圈最新动态，夜间也有值班编辑更新，不错过任何一个猛料。',
    link: '/about',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家爆料验证',
    description: '每条爆料都经过多重交叉验证，确保信息真实可靠，杜绝虚假谣言传播。',
    link: '/about',
  },
  {
    icon: 'ri-global-line',
    title: '全网热点聚合',
    description: '聚合微博、抖音、小红书等全网平台的热点内容，一站式吃瓜不迷路。',
    link: '/category/mingxing-bagua',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私安全保护',
    description: '匿名投稿机制严格保护爆料人隐私，采用端到端加密技术确保信息安全。',
    link: '/about',
  },
];

export default function FeatureGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-foreground-600 text-xs font-medium mb-3 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            平台特色导视
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            51黑料吃瓜网的核心优势，让你的吃瓜体验与众不同
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.link}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-white/20 transition-colors">
                <i className={`${feature.icon} text-xl text-secondary-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-white mb-2 transition-colors whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 group-hover:text-white/80 leading-relaxed mb-3 transition-colors">
                {feature.description}
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-400 group-hover:text-white/70 transition-colors whitespace-nowrap">
                了解更多
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}